module.exports = __webpack_public_path__ + "static/img/zhangtiequan.ccff6a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/zhangtiequan.jpg
// module id = nZ9i
// module chunks = 1